module.exports = __webpack_public_path__ + "img/1-3.c17a7fd8.jpg";